const courierDocumentBaseUrl = 'https://storage.vozovoz.ru/src-main/documents/2026/courier/Документы%20по%20Курьерской%20услуги%20на%20сайты%20компаний'

const courierDocumentTemplates = [
  {
    title: 'Договор курьерской доставки',
    description: 'Условия оказания услуги, порядок приёма, доставки, выдачи и оплаты отправлений.',
    fileName: 'Договор%20на%20оказание%20услуг%20по%20курьерской%20доставке'
  },
  {
    title: 'Какие отправления не принимаются к доставке',
    description: 'Перечень товаров и вложений, которые нельзя передавать для перевозки.',
    fileName: 'Перечень%20отправлений%2C%20не%20принимаемых%20к%20доставке'
  },
  {
    title: 'Требования к защитной упаковке',
    description: 'Какие отправления необходимо перевозить в защитной транспортной упаковке и требования к ней.',
    fileName: 'Отправления%20подлежащие%20обязательной%20ЗТУ'
  },
  {
    title: 'Какие отправления не подлежат страхованию',
    description: 'Перечень категорий, на которые не распространяется страхование отправления.',
    fileName: 'Отправления%2C%20не%20подлежащие%20страхованию'
  }
]

function createCourierDocumentItems(companyName) {
  return courierDocumentTemplates.map(({fileName, ...item}) => ({
    ...item,
    href: `${courierDocumentBaseUrl}/${companyName}/${fileName}%20${companyName}.pdf`
  }))
}

export const severTransCourierDeliveryConfig = {
  terminalBrandName: 'СЕВЕРТРАНС',
  documentItems: createCourierDocumentItems('СТЭК')
}

export const ugTransCourierDeliveryConfig = {
  terminalBrandName: 'ЮГТранс ТЭК',
  documentItems: createCourierDocumentItems('ЮТТ')
}

export const transportCourierDeliveryConfig = {
  terminalBrandName: '«Транспортных технологий»',
  documentItems: createCourierDocumentItems('ТТ')
}
